var _defs, _polygon, _polygon2, _polygon3, _polygon4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUcsm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "UCSM Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 262 255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ucsm-cls-1,.ucsm-cls-4{stroke:#034669;}.ucsm-cls-1,.ucsm-cls-3,.ucsm-cls-4{stroke-miterlimit:10;stroke-width:2px;}.ucsm-cls-1,.ucsm-cls-2,.ucsm-cls-3,.ucsm-cls-4{fill-rule:evenodd;}.ucsm-cls-1{fill:url(#linear-gradient);}.ucsm-cls-2{fill:url(#linear-gradient-2);}.ucsm-cls-3{stroke:#196b89;fill:url(#linear-gradient-3);}.ucsm-cls-4{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 136.36,
    y1: 23.23,
    x2: 136.36,
    y2: 123.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#949cb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#798ca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#476e8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#235879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0d4b6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 136.36,
    y1: 123.13,
    x2: 136.36,
    y2: 222.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cae6ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4284a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 78.68,
    y1: 122.89,
    x2: 78.68,
    y2: 222.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5c1cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#86afbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5692a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#337d97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1e708d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#166b89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 194.04,
    y1: 122.89,
    x2: 194.04,
    y2: 222.79,
    xlinkHref: "#linear-gradient"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "ucsm-cls-1",
    points: "136.36 123.13 78.68 123.13 107.52 73.18 136.36 23.23 165.2 73.18 194.04 123.13 136.36 123.13"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "ucsm-cls-2",
    points: "136.36 123.13 193.9 123.13 165.13 172.96 136.36 222.79 107.59 172.96 78.83 123.13 136.36 123.13"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "ucsm-cls-3",
    points: "78.68 222.79 21 222.79 49.84 172.84 78.68 122.89 107.52 172.84 136.36 222.79 78.68 222.79"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "ucsm-cls-4",
    points: "194.04 222.79 136.36 222.79 165.2 172.84 194.04 122.89 222.88 172.84 251.72 222.79 194.04 222.79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcsm);
export default __webpack_public_path__ + "static/media/UCSM.0cdbc6921df2060866ac0f911b16235a.svg";
export { ForwardRef as ReactComponent };